"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareErc998ContractsInitialValues = exports.erc998EditContractFilter = void 0;
const types_1 = require("../../../../types");
const erc998EditContractFilter = (service) => ({ title, description, contractStatus, imageUrl, merchantId }) => ({
    title,
    description,
    imageUrl,
    contractStatus,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.erc998EditContractFilter = erc998EditContractFilter;
const prepareErc998ContractsInitialValues = (service) => ({ id, title, description, imageUrl, contractStatus, address, merchantId }) => {
    return {
        id,
        title,
        address,
        description,
        contractStatus,
        imageUrl,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareErc998ContractsInitialValues = prepareErc998ContractsInitialValues;
//# sourceMappingURL=schemas.js.map